import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { HelpCircle } from "lucide-react";

const faqs = [
  {
    q: "Is it really free for me as the employer?",
    a: "Yes. Our voluntary benefit programs are paid by the employees who choose them, so your team gets quality coverage and you add a stronger benefits package — with no hit to your bottom line. (A few optional upgrades, like our $10K group life offer at $2 per employee, are employer paid if you want them, but they're never required.)",
  },
  {
    q: "What's the catch?",
    a: "There isn't one. We're paid by the insurance carriers, not by you. Your employees only pay for the coverage they personally choose to enroll in, and they're never obligated to sign up for anything.",
  },
  {
    q: "How many employees do I need?",
    a: "Most of our programs work well for small and mid size teams. Our $10K group term life offer is available for businesses with 10 or more eligible employees, but we have solutions for smaller teams too — just ask.",
  },
  {
    q: "Do my employees have to participate?",
    a: "No. These are voluntary benefits, so each employee decides what's right for them and their family. You're simply giving them access to coverage they couldn't easily get on their own.",
  },
  {
    q: "How long does enrollment take?",
    a: "For most businesses, we can get everything set up and your team enrolled within a couple of weeks. We handle the scheduling, the meetings, and the paperwork.",
  },
  {
    q: "What kind of coverage can my team get?",
    a: "Dental, vision, supplemental insurance, and group life and disability. We'll help you decide which options make sense for your business.",
  },
  {
    q: "Are you local?",
    a: "We are. We live and work right here in North Dakota, and we meet with you face to face. When you call, you talk to Joey or Levi — not a call center.",
  },
];

// FAQPage Schema.org JSON-LD for Google rich snippets
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map((f) => ({
    "@type": "Question",
    "name": f.q,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": f.a,
    },
  })),
};

export const FAQSection = () => (
  <section data-testid="faq-section" className="py-20 bg-[#F8FAFC]">
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <div className="inline-flex items-center space-x-2 bg-[#EAF9F9] text-[#2EC4C4] font-semibold text-xs uppercase tracking-wider px-4 py-2 rounded-full mb-5">
          <HelpCircle size={14} />
          <span>Frequently Asked Questions</span>
        </div>
        <h2 className="font-bold text-3xl lg:text-4xl text-[#1A2744] mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Questions Business Owners Ask Us
        </h2>
        <p className="text-[#475569] text-lg max-w-2xl mx-auto">
          Quick, straight answers to the questions we get most often.
        </p>
      </div>

      <Accordion type="single" collapsible className="bg-white rounded-2xl border border-gray-100 shadow-sm px-6 sm:px-8">
        {faqs.map((faq, i) => (
          <AccordionItem
            key={faq.q}
            value={`faq-${i}`}
            data-testid={`faq-item-${i}`}
            className="border-b border-gray-100 last:border-0"
          >
            <AccordionTrigger className="text-left font-semibold text-base sm:text-lg text-[#1A2744] py-5 hover:no-underline" style={{ fontFamily: "'Outfit', sans-serif" }}>
              {faq.q}
            </AccordionTrigger>
            <AccordionContent className="text-[#475569] text-sm sm:text-base leading-relaxed pb-5">
              {faq.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
